import gql from "graphql-tag";
import {useQuery} from "react-apollo";
import {ManifestPrintoutLayoutListingFragment} from "Queries/Printout";
import {ManifestPrintoutLayoutListing} from "__generated__/graphql/types";

const ListManifestPrintoutLayouts = gql`
    query ListMultiFlightManifestLayouts($manifestType: String!) {
        ListManifestPrintoutLayouts(manifestType: $manifestType) {
            ...ManifestPrintoutLayoutListingFragment
        }
    }
    ${ManifestPrintoutLayoutListingFragment}
`

export function useManifestPrintoutLayoutsQuery(manifestType: string){
    const result = useQuery(ListManifestPrintoutLayouts, {
        variables: {
            manifestType: manifestType
        },
        skip: !manifestType,
        fetchPolicy: 'cache-and-network'
    });

    return {
        ...result,
        layouts: (result.data?.ListManifestPrintoutLayouts || []) as ManifestPrintoutLayoutListing[]
    }
}